/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import React from 'react';
import { Route } from 'react-router';

import ErrorBoundaryRoutes from 'app/shared/error/error-boundary-routes';

import CashTransaction from './cash-transaction';
import CashTransactionDetail from './cash-transaction-detail';
import CashTransactionUpdate from './cash-transaction-update';
import CashTransactionDeleteDialog from './cash-transaction-delete-dialog';

const CashTransactionRoutes = () => (
  <ErrorBoundaryRoutes>
    <Route index element={<CashTransaction />} />
    <Route path="new" element={<CashTransactionUpdate />} />
    <Route path=":id">
      <Route index element={<CashTransactionDetail />} />
      <Route path="edit" element={<CashTransactionUpdate />} />
      <Route path="delete" element={<CashTransactionDeleteDialog />} />
    </Route>
  </ErrorBoundaryRoutes>
);

export default CashTransactionRoutes;
